import React, { useState } from 'react'
import { getImages } from '../components/Common/const'
import ModalLayout from '../components/Common/ModalLayout'
import ScheduleServiceModal from '../components/ScheduleService/ScheduleServiceModal';

const ServiceCenter = () => {
    const [openScheduleServiceModal, setOpenScheduleServiceModal] = useState(false);
    const handleScheduleService = () => {
        setOpenScheduleServiceModal(true)
    }
    const closeScheduleModal = () => {
        setOpenScheduleServiceModal(false)
    }
  return (
    <>
        <section className='common-banner-wrap sc-banner-wrap position-relative'>
            <img src={getImages('Service-Center1.jpg')}/>
            <div className='cb-pos'>
                <div className='xl-title text-uppercase'>Service Center</div>
                <div className='mt-5 text-center cb-title'>
                    <button type='button' className='btn-theme w-330 text-gray' onClick={handleScheduleService}>Schedule Service</button>
                </div>
            </div>
        </section>
        <section className='service-center-wrap'>
            <div className='container'>
                <div className='lg-title text-uppercase mb-5'>The highest level of service</div>
                <div className='row hls-row'>
                    <div className='col-lg-4 col-12'>
                        <p>Mark Motors would like to guide you through the process and work with you each step of the way. Please call us if you have maintenance or repair needs or concerns.</p>

                        <p>It is our commitment to you to provide the highest level of service. We have developed our culture around you and your needs. We act with your permission. We are here not only to service your vehicle, but to be of service to you.</p>
                    </div>
                    <div className='col-lg-8 col-12'>
                        <ul className='hls-list'>
                            <li><div className='hls-box'><span className='hls-icon'></span> Alignment & Rotation</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Oil & Fluid Check</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Schedule Maintenance</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Wheel Color Change</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Ceramic Coating</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Paint and Body Restoration</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Collision Repair</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Wheel Refinishing</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Wheel Color Change</div></li>
                            <li><div className='hls-box'><span className='hls-icon'></span> Ceramic Coating</div></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section className='sc-services-wrap'>
            <div className='container'>
                {/* <div className='row sc-services-flex'>
                    <div className='col-lg-6 col-12'>
                        <div className='sc-service-box'>
                            <div className='sc-image'>
                                <img src={getImages('sc-img1.webp')}/>
                            </div>
                            <div className='sc-content'>
                                <div className='md-title text-uppercase'>ALIGNMENT & ROTATION</div>
                                <div className='my-4'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                                </div>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div>
                                        <div className='md-title'>$000.00</div>
                                        <div className='xs-title fw-400 opacity-0-7'>Regular Price: $600</div>
                                    </div>
                                    <div>
                                        <button type='button' className='btn-theme'>Book Service</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='sc-service-box'>
                            <div className='sc-image'>
                                <img src={getImages('sc-img2.webp')}/>
                            </div>
                            <div className='sc-content'>
                                <div className='md-title text-uppercase'>OIL & FLUID CHECK</div>
                                <div className='my-4'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                                </div>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div>
                                        <div className='md-title'>$000.00</div>
                                        <div className='xs-title fw-400 opacity-0-7'>Regular Price: $600</div>
                                    </div>
                                    <div>
                                        <button type='button' className='btn-theme'>Book Service</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='ss-box cr-box mt-5 mb-md-4'>
                    <div className='md-title text-uppercase text-center'>Our technicians are Commited to your service</div>
                    <div className='text-center mt-5'>
                        <button type='button' className='btn-theme text-gray w-330' onClick={handleScheduleService}>Schedule Service</button>
                    </div>
                </div>
            </div>
        </section>
        <section className='contact-info-wrap sc-ci-wrap'>
            <div className='container'>
                <div className='row mlr-60'>
                    <div className='col-lg-6'>
                        <iframe className='ci-iframe' src="https://snazzymaps.com/embed/686106" width="100%" height="400px" ></iframe>
                    </div>
                    <div className='col-lg-6'>
                        <div className='md-title fw-400 mb-2'>Boerne, TX</div>
                        <div className='gt-address mb-3'>140 Enterprise Parkway Boerne, TX 78006</div>
                        <div className='md-title fw-500 mb-3'>830-981-5050</div>
                        <div className='gt-address mb-2 text-uppercase'>Service Hours</div>
                        <div className='sc-ci-table'>
                            <table className='w-100'>
                                <tbody>
                                    <tr>
                                        <th>Monday</th>
                                        <td>7am - 5pm</td>
                                    </tr>
                                    <tr>
                                        <th>Tuesday</th>
                                        <td>7am - 5pm</td>
                                    </tr>
                                    <tr>
                                        <th>Wednesday</th>
                                        <td>7am - 5pm</td>
                                    </tr>
                                    <tr>
                                        <th>Thrusday</th>
                                        <td>7am - 5pm</td>
                                    </tr>
                                    <tr>
                                        <th>Friday</th>
                                        <td>7am - 5pm</td>
                                    </tr>
                                    <tr>
                                        <th>Sat & Sun</th>
                                        <td>Closed</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ModalLayout open={openScheduleServiceModal} close={closeScheduleModal} cls='schedule-service-modal' modalWidth={1198}>
            <ScheduleServiceModal close={closeScheduleModal}/>
        </ModalLayout>
    </>
  )
}

export default ServiceCenter